export class Application {
  id: number = 0;
  titel: string = '';
  beschreibung: string = '';
  
  userId: string = '';
  createdAt: Date = new Date();
  updatedAt: Date = new Date();
}